import md5 from "md5";

export function encryptByWeb(password){
  return password + '' ? md5(password + '') : '';
}